import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SliderSection, completedSlides } from '../components/SliderSection';
import { api } from '../services/api';
import { setSiteMeta } from '../utils/meta';

export const CompletedPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [voteNumber, setVoteNumber] = useState<number | string>(() => {
    const stateVote = (location.state as any)?.voteNumber;
    if (stateVote) return stateVote;
    const stored = localStorage.getItem('userVoteCount');
    if (stored) return stored;
    return '...';
  });

  // Report problem form state
  const [reportName, setReportName] = useState('');
  const [reportEmail, setReportEmail] = useState('');
  const [reportMessage, setReportMessage] = useState('');
  const [reportSuccess, setReportSuccess] = useState(false);

  useEffect(() => {
    const election = api.getElectionSettingsSync();
    setSiteMeta({ election, pageTitle: 'Congratulations - Vote Confirmed' });

    // If voteNumber wasn't passed, fetch it
    if (voteNumber === '...' || !voteNumber) {
      api.getTotalVoted().then((count) => {
        if (count) {
          setVoteNumber(count);
          localStorage.setItem('userVoteCount', String(count));
        }
      });
    }
  }, [voteNumber]);

  const handleReportSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await api.submitReport(reportName, reportEmail, reportMessage);
    setReportSuccess(true);
    setReportName('');
    setReportEmail('');
    setReportMessage('');
  };

  return (
    <>
      <div className="eqd-main">
        {/* First Section */}
        <div className="eqd-left">
          {/* Header */}
          <Header />

          {/* Cast Your Vote / Completed */}
          <div className="eqdl-main">
            <div className="main-texts">
              <div className="main-header">
                <h2>You have voted successfully!</h2>
              </div>
              <div className="main-paragraph mp-completed">
                <p> Your vote counted as number <h4 id="userVoteCount">{voteNumber}</h4>.</p>
                <p> Thank you for participating in the democratic process with Electpoll! We sent you an email to review how the election went for you. Your opinion would help us improve.</p>
              </div>
            </div>
            <div className="main-ctas">
              <a
                href="/"
                className="mc-primary"
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/');
                }}
              >
                <p>Return Home</p>
              </a>
              <a
                href="https://electpoll.com"
                target="_blank"
                rel="noreferrer"
                className="mc-secondary"
              >
                <p>Learn More</p>
              </a>
            </div>
          </div>

          {/* Footer (Desktop) */}
          <div className="dt-foot"></div>
        </div>

        {/* Second Section */}
        <div className="eqd-right">
          {/* Sliders (Legacy simg4, simg5, simg6) */}
          <SliderSection slides={completedSlides} />

          {/* Footer (Mobile) */}
          <div className="mb-foot"></div>
        </div>
      </div>

      {/* Report A Problem */}
      <div className="report-a-problem">
        <div className="rap-form">
          <form id="rapf" onSubmit={handleReportSubmit}>
            <div className="rapf-head">
              <h2>Report A Problem</h2>
              <p>Having any issue with the site? You can report the problem to us. We'll be sure to get back to you.</p>
            </div>
            {reportSuccess ? (
              <div
                style={{
                  padding: '20px',
                  backgroundColor: '#ECFDF5',
                  border: '1px solid #10B981',
                  borderRadius: '4px',
                  textAlign: 'center',
                  color: '#065F46',
                  fontWeight: 600,
                  marginBottom: '20px',
                }}
              >
                Thank you! Your report has been dispatched to the electoral support desk.
              </div>
            ) : (
              <>
                <div className="rapf-inputs">
                  <input
                    type="text"
                    id="report-name"
                    placeholder="Your Name"
                    value={reportName}
                    onChange={(e) => setReportName(e.target.value)}
                    required
                  />
                  <input
                    type="email"
                    id="report-email"
                    placeholder="Your Email"
                    value={reportEmail}
                    onChange={(e) => setReportEmail(e.target.value)}
                    required
                  />
                </div>
                <textarea
                  name="report-message"
                  id="report-message"
                  cols={30}
                  rows={10}
                  placeholder="Message"
                  value={reportMessage}
                  onChange={(e) => setReportMessage(e.target.value)}
                  required
                ></textarea>
                <div className="rapf-cta">
                  <button type="submit" id="rapf-submit">
                    <p>Send Message</p>
                  </button>
                </div>
              </>
            )}
          </form>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </>
  );
};
